import { i18next, linkEditing } from '@yola/ws-sdk';

const { linkTypes } = linkEditing.constants;

const getLinkTypeOptions = (allowedTypes, isBindingsEnabled = false) => {
  const options = [
    {
      label: i18next.t('No action'),
      value: linkTypes.NO_ACTION,
    },
    {
      label: i18next.t('View full-size image'),
      value: linkTypes.VIEW_FULL_SIZE_IMAGE,
    },
    {
      label: i18next.t('Open a page'),
      value: linkTypes.PAGE,
    },
    {
      label: i18next.t('Scroll to a block'),
      value: linkTypes.ANCHOR,
    },
    {
      label: i18next.t('Open a web address'),
      value: linkTypes.EXTERNAL,
    },
    {
      label: i18next.t('Make a phone call'),
      value: linkTypes.PHONE,
    },
    {
      label: i18next.t('Send an email'),
      value: linkTypes.MAIL,
    },
    {
      label: i18next.t('Download a file'),
      value: linkTypes.DOWNLOAD,
    },
  ].filter((option) => allowedTypes.includes(option.value));

  if (isBindingsEnabled) {
    options.push({ label: i18next.t('Connect to CMS...'), value: 'binding' });
  }

  return [
    {
      label: i18next.t('Select an action'),
      options,
    },
  ];
};

export default getLinkTypeOptions;
